import { RootState } from '../index';
import { createDraftSafeSelector } from '@reduxjs/toolkit';

const notifications = (state: RootState) => state.notifications.notifications;

const selectNotifications = createDraftSafeSelector(
  notifications,
  (notifications) => notifications,
);

export { selectNotifications };
